/**
 *
 * @param {type} resolve - коллбэк в случае успеха
 * @param {type} reject - коллбык в случае ошибки
 * @returns {undefined}
 */
export function all(resolve, reject) {
    BX24.callMethod(
        'user.get',
        {},
        function (result) {
            if (result.error()) {
                reject(result.error());
            } else {
                resolve(result.data());

                if (result.more()) {
                    result.next();
                }
            }
        }
    );
}

window.addEventListener('load', function() {
    if (!isBx24Context) {
        return true;
    }
    if (!window.hasOwnProperty('optionList')) {
        return true;
    }
    let options = optionList;
    if (options.hasOwnProperty('autosave')) {
        return true;
    }

    BX24.callMethod('user.option.get', {}, result =>
    {
        let legacyOptions = result.data();
        let autosave = null;
        if (legacyOptions.hasOwnProperty('kb_autosave')) {
            autosave = 'false';
            if (legacyOptions.kb_autosave == 'on') {
                autosave = 'true';
            }
        }
        if (autosave !== null) {
            Options.setValue(kbOptions.autosave, autosave, syncAutoSaveButton);
        }
    });

    return true;
});
